import React from "react";
import { Card, Button, Typography, Space } from "antd";

const { Title, Paragraph, Text } = Typography;

export default function Firewalls() {
  return (
    <Space
      direction="vertical"
      size="large"
      style={{ width: "100%" }}
    >
      <Card>
        <Title level={5}>FIREWALLS</Title>

        <Paragraph>
          Firewalls allow you to restrict or allow traffic based
          on rules. Inbound rules define the traffic that is
          allowed, all other inbound traffic will be dropped.
          All outbound traffic is allowed as long as no outbound
          rule is specified.
        </Paragraph>

        <Paragraph>
          <Text type="secondary">
            No Firewalls have been applied to your server yet.
          </Text>
        </Paragraph>

        <Space>
          <Button danger type="primary">
            Create Firewall
          </Button>
          <Button disabled>Apply Firewall</Button>
        </Space>
      </Card>
    </Space>
  );
}
